import React from 'react';
import { Label } from '../ui/label';
import { Zap } from 'lucide-react';
import { StatusOption, ReflexSelect, SideSelector } from './ExamFormControls';

const SpinalReflexesSection = ({ formData, handleChange, readOnly }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 p-3 bg-[#F8F7F4] rounded-lg">
        <Zap className="w-4 h-4 text-[#4B6651]" />
        <span className="text-sm text-[#5C5F5C]">
          Grade reflexes: 0=Absent, +1=Decreased, +2=Normal, +3=Increased, +4=Clonus
        </span>
      </div>

      <div>
        <Label className="text-[#2A2C2A] font-medium mb-3 block">Patellar Reflex (L4-L6)</Label>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label className="text-sm text-[#5C5F5C]">Left</Label>
            <ReflexSelect value={formData.patellar_left} onChange={(v) => handleChange('patellar_left', v)} testId="patellar-left" readOnly={readOnly} />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-[#5C5F5C]">Right</Label>
            <ReflexSelect value={formData.patellar_right} onChange={(v) => handleChange('patellar_right', v)} testId="patellar-right" readOnly={readOnly} />
          </div>
        </div>
      </div>

      <div>
        <Label className="text-[#2A2C2A] font-medium mb-3 block">Withdrawal Reflex - Thoracic (C6-T2)</Label>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label className="text-sm text-[#5C5F5C]">Left</Label>
            <ReflexSelect value={formData.withdrawal_thoracic_left} onChange={(v) => handleChange('withdrawal_thoracic_left', v)} testId="withdrawal-thoracic-left" readOnly={readOnly} />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-[#5C5F5C]">Right</Label>
            <ReflexSelect value={formData.withdrawal_thoracic_right} onChange={(v) => handleChange('withdrawal_thoracic_right', v)} testId="withdrawal-thoracic-right" readOnly={readOnly} />
          </div>
        </div>
      </div>

      <div>
        <Label className="text-[#2A2C2A] font-medium mb-3 block">Withdrawal Reflex - Pelvic (L4-S3)</Label>
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label className="text-sm text-[#5C5F5C]">Left</Label>
            <ReflexSelect value={formData.withdrawal_pelvic_left} onChange={(v) => handleChange('withdrawal_pelvic_left', v)} testId="withdrawal-pelvic-left" readOnly={readOnly} />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-[#5C5F5C]">Right</Label>
            <ReflexSelect value={formData.withdrawal_pelvic_right} onChange={(v) => handleChange('withdrawal_pelvic_right', v)} testId="withdrawal-pelvic-right" readOnly={readOnly} />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-[#2A2C2A] font-medium">Perineal Reflex (S1-S3)</Label>
          <div className="flex gap-1 flex-wrap">
            <StatusOption value="normal" label="Normal" selected={formData.perineal_reflex === 'normal'} onChange={(v) => handleChange('perineal_reflex', v)} readOnly={readOnly} />
            <StatusOption value="abnormal" label="Abnormal" selected={formData.perineal_reflex === 'abnormal'} onChange={(v) => handleChange('perineal_reflex', v)} readOnly={readOnly} />
            <StatusOption value="unable_to_evaluate" label="U/E" selected={formData.perineal_reflex === 'unable_to_evaluate'} onChange={(v) => handleChange('perineal_reflex', v)} readOnly={readOnly} />
          </div>
        </div>
        <div className="space-y-2">
          <Label className="text-[#2A2C2A] font-medium">Cutaneous Trunci (T2-L5)</Label>
          <div className="flex gap-1 flex-wrap">
            <StatusOption
              value="normal"
              label="Normal"
              selected={formData.cutaneous_trunci === 'normal'}
              onChange={(v) => { handleChange('cutaneous_trunci', v); handleChange('cutaneous_trunci_side', ''); }}
              readOnly={readOnly}
            />
            <StatusOption
              value="abnormal"
              label="Abnormal"
              selected={formData.cutaneous_trunci === 'abnormal'}
              onChange={(v) => handleChange('cutaneous_trunci', v)}
              readOnly={readOnly}
            />
            <StatusOption
              value="unable_to_evaluate"
              label="U/E"
              selected={formData.cutaneous_trunci === 'unable_to_evaluate'}
              onChange={(v) => { handleChange('cutaneous_trunci', v); handleChange('cutaneous_trunci_side', ''); }}
              readOnly={readOnly}
            />
          </div>
          <SideSelector field="cutaneous_trunci" show={formData.cutaneous_trunci === 'abnormal'} formData={formData} handleChange={handleChange} readOnly={readOnly} />
        </div>
      </div>
    </div>
  );
};

export default SpinalReflexesSection;
